const isDev = import.meta.env.DEV;

type LogArgs = unknown[];

export const logger = {
  error: (...args: LogArgs) => {
    console.error(...args);
  },
  warn: (...args: LogArgs) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  info: (...args: LogArgs) => {
    if (isDev) {
      console.info(...args);
    }
  },
  debug: (...args: LogArgs) => {
    if (isDev) {
      console.debug(...args);
    }
  },
};

export default logger;
